import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import * as yup from 'yup'
import { routes, api } from 'config'
import { processErrorMsg, removeFocusFromField } from 'utils'
import { BaseLayout, Loader } from 'components'
import useStyles from '../mfa/mfa-style'
import { MfaOtpForm } from 'pages/mfa/components'
import Axios from 'axios'

function UpdateEnrollmentOtpForm() {
  const navigate = useNavigate()
  const location = useLocation()
  const { oktaAuth } = useOktaAuth()
  const [transaction, setTransaction] = useState<any | {}>({})
  const [showLoader, setShowLoader] = useState(false)
  const [serviceError, setServiceError] = useState('')
  const [count, setCount] = useState(5)
  const { classes } = useStyles()
  const state = location.state as {
    transaction: any
    phoneNumber: string
  }
  //set states for forwared transaction details
  const forwardedTransaction = state?.transaction
  const phoneNumber = state?.phoneNumber
  const factorId = state?.transaction?.id

  useEffect(() => {
    setTransaction(forwardedTransaction)
  }, [forwardedTransaction])

  let validationSchema: any
  let initialValues: any

  const processSuccess = (response: any) => {
    setShowLoader(false)
    localStorage.setItem('mobileNumber', phoneNumber)
    setTransaction(response)
    navigate(routes.mfa)
  }
  const decreaseCount = () => {
    let localCount: any = localStorage.getItem('COUNT')
    if (JSON.parse(localCount) >= 2) {
      setCount(JSON.parse(localCount) - 1)

      setTimeout(() => {
        localStorage.setItem('COUNT', JSON.stringify(--localCount))
      }, 700)
    } else {
      localStorage.removeItem('COUNT')
    }
  }

  const processError = (
    e: any,
    module: string,
    moduleDescription: string = '',
  ) => {
    setShowLoader(false)
    setServiceError(processErrorMsg(e, module, moduleDescription))
  }

  const handleResend = (event: any) => {
    event.stopPropagation()
    event.preventDefault()
    try {
      console.log('call otp resend here')
    } catch (e) {
      processError(e, 'MFA', 'Resending MFA OTP code')
    }
  }
  if (transaction.sessionToken) {
    oktaAuth.signInWithRedirect({
      sessionToken: transaction.sessionToken,
    })

    return null
  }
  validationSchema = yup.object().shape({
    verificationCode: yup.string().required('Required').length(6),
  })
  initialValues = {
    verificationCode: '',
  }
  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    removeFocusFromField()
    setSubmitting(true)
    setServiceError('')
    setShowLoader(true)
    decreaseCount()

    setShowLoader(true)
    const passCode = values.verificationCode
    const accessToken = localStorage.getItem('accessToken')

    await Axios.post(api.updateFactorDetails(), {
      accessToken,
      factorId,
      passCode,
    })
      .then(processSuccess)
      .catch((e) => {
        setShowLoader(false)
        setServiceError(
          processErrorMsg(
            e,
            'Update Factor Details',
            'Unable to update Phone Number for SMS factor Error with OTP',
          ),
        )
      })
      .then(() => setSubmitting(false))
  }
  return (
    <BaseLayout boxLayoutClassName={classes.mfaContainer}>
      <Loader visible={showLoader} />
      <MfaOtpForm
        phoneNumber={phoneNumber}
        transaction={transaction}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        serviceError={serviceError}
        validationSchema={validationSchema}
        count={count}
        handleResend={handleResend}
        setShowLoader={setShowLoader}
      />
    </BaseLayout>
  )
}

export default UpdateEnrollmentOtpForm
